export const LOCAL_STORAGE_VAR = {
    VEHICLE_LIST_HEIGHT: 'VEHICLE_LIST_HEIGHT',
    VEHICLE_BOTTOM_LIST_WRAPPER_HEIGHT: 'VEHICLE_BOTTOM_LIST_WRAPPER_HEIGHT',
    VEHICLE_FULL_LIST_SORT_COLUMNS_CONFIG: 'VEHICLE_FULL_LIST_SORT_COLUMNS_CONFIG',
    APP_NEWS_SHOW_ONE_MONTH: 'APP_NEWS_SHOW_ONE_MONTH',
};
